export const routes = [
  ...require('./carrier/routes').routes
]
